import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarFilterButton,
} from '@mui/x-data-grid-pro';

export const CmdiDataGridToolbar = () => {
  return (
    <GridToolbarContainer sx={{ padding: 2, borderBottomWidth: 1, borderColor: 'divider', borderBottomStyle: 'solid' }}>
      <GridToolbarFilterButton />
      <GridToolbarColumnsButton />
      <GridToolbarDensitySelector />
    </GridToolbarContainer>
  );
};
